

export default (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/view/window/get-window-scroll.js
// module id = 123
// module chunks = 0